import { ChangeDetectorRef, Component, OnInit, ViewChild, ElementRef } from '@angular/core';

import { Subject, Observable, forkJoin, of } from 'rxjs';

import { environment } from 'environments/environment';
import { debounceTime, map, switchMap, catchError } from 'rxjs/operators';

import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { SystemSettingService } from '@app/api/systemsettting.service';

import { ToastrService } from 'ngx-toastr';

import * as _moment from 'moment';
import { SystemSettingStore } from '@app/services/change-setting.service';
interface MediaItem {
  url: string;
  isNew: boolean;
  file: File;
  id: string;
  is_hidden: boolean;
  parent_id?: number;
  value?: string;
}

@Component({
  selector: 'general-settings.component',
  templateUrl: './general-settings.component.html',
  styleUrls: ['./general-settings.component.scss'],
})
export class AppGeneralSettingsComponent implements OnInit {
  @ViewChild('logoContainer', { static: false }) logoContainer: ElementRef;
  @ViewChild('faviconContainer', { static: false }) faviconContainer: ElementRef;
  @ViewChild('bannerContainer', { static: false }) bannerContainer: ElementRef;
  lstLogo: MediaItem[] = [];
  lstFavicon: MediaItem[] = [];

  lstBanner: MediaItem[] = [];
  type = {
    header: 'HEADER-ICONS',
    favicon: 'FAVICON',
    hotline: 'HOTLINE-CALL',
    video: 'VIDEO',
    banner: 'BANNER',
    email: 'EMAIL',
  };

  selectedLogo: File;
  selectedFavicon: File;

  hotline: string = '';
  linkYtb: string = '';
  email: string = '';

  imgTestLogo: any;
  private scrollAmount = 300;
  constructor(
    private sysService: SystemSettingService,
    private sanitizer: DomSanitizer,
    private cdr: ChangeDetectorRef,
    private toastr: ToastrService,
    private storeSetting: SystemSettingStore
  ) {}

  ngOnInit() {
    this.renderData();
  }

  scrollRight(type: 'logo' | 'favicon' | 'banner') {
    let container;
    if (type === 'logo') {
      container = this.logoContainer;
    } else if (type === 'favicon') {
      container = this.faviconContainer;
    } else {
      container = this.bannerContainer;
    }

    if (!container) return;

    const element = container.nativeElement;
    const maxScroll = element.scrollWidth - element.clientWidth;
    const currentScroll = element.scrollLeft;

    if (currentScroll < maxScroll) {
      element.scrollTo({
        left: currentScroll + this.scrollAmount,
        behavior: 'smooth',
      });
    }
  }

  scrollLeft(type: 'logo' | 'favicon' | 'banner') {
    let container;
    if (type === 'logo') {
      container = this.logoContainer;
    } else if (type === 'favicon') {
      container = this.faviconContainer;
    } else {
      container = this.bannerContainer;
    }

    if (!container) return;

    const element = container.nativeElement;
    const currentScroll = element.scrollLeft;

    if (currentScroll > 0) {
      element.scrollTo({
        left: currentScroll - this.scrollAmount,
        behavior: 'smooth',
      });
    }
  }

  getData(type): Observable<any> {
    return this.sysService.apiSystemSettingGet(`type==${type}`).pipe(
      map((res) => {
        console.log(res, 'ngay lan dau tien', type);
        if (res.success && res.data.collection.length > 0) {
          const parent = res.data.collection[0];
          if (parent.children && parent.children.length > 0) {
            return parent.children
              .filter((item) => item.value !== null && item.value !== '')
              .map((item) => {
                return {
                  id: item.id,
                  url: environment.backendhost + item.value,
                  isNew: false,
                  file: null,
                  is_hidden: item.is_hidden,
                  parent_id: parent.id,
                  value: item.value,
                };
              });
          }
        }
        return [];
      }),
      catchError(() => of([]))
    );
  }

  onSelectedImage(event: any, type: 'logo' | 'favicon' | 'banner') {
    const files: FileList = event.target.files;
    if (!files || files.length === 0) return;

    const file = files[0];
    const preview = URL.createObjectURL(file);
    const safeUrl: SafeUrl = this.sanitizer.bypassSecurityTrustUrl(preview);

    const newImage: MediaItem = {
      url: safeUrl as string,
      isNew: true,
      file: file,
      id: '',
      is_hidden: type === 'banner' ? false : true,
    };

    if (type === 'logo') {
      this.lstLogo.push(newImage);
    } else if (type === 'favicon') {
      this.lstFavicon.push(newImage);
    } else {
      this.lstBanner.push(newImage);
    }

    event.target.value = '';
  }

  checkExistType(type: string): Observable<{ exists: boolean; id?: number }> {
    const filter = `type==${type}`;
    return this.sysService.apiSystemSettingGet(filter).pipe(
      map((res) => {
        if (res.success && res.data.collection.length > 0) {
          const item = res.data.collection.find((item) => item.type === type);
          if (item) {
            return { exists: true, id: item.id };
          }
        }
        return { exists: false };
      })
    );
  }

  postData(obj: any): Observable<any> {
    return this.sysService.apiSystemSettingPost(obj);
  }

  putData(obj: any, id: any): Observable<any> {
    console.log('Updating with data:', obj, 'for id:', id);
    return this.sysService.apiSystemSettingIdPut(id, obj);
  }

  activeItem(item: MediaItem, type: 'Logo' | 'Favicon' | 'Banner') {
    let list;
    if (type === 'Logo') {
      list = this.lstLogo;
    } else if (type === 'Favicon') {
      list = this.lstFavicon;
    } else {
      list = this.lstBanner;
    }

    if (type === 'Banner') {
      item.is_hidden = !item.is_hidden;
    } else {
      list.forEach((data) => {
        data.is_hidden = data !== item;
      });
    }

    this.cdr.detectChanges();
  }

  private saveImageByType(type: string, images: MediaItem[], page_location: string) {
    return this.checkExistType(type).pipe(
      // 1. Get or create parent item
      switchMap((result) => {
        const parentObj = {
          type,
          sort_order: 0,
          parent_title: type,
          page_location: page_location,
          language: 'vi',
        };

        return result.exists ? of(result.id) : this.postData(parentObj).pipe(map((r) => r.data.id));
      }),

      // 2. Process new and existing items
      switchMap((parentId) => {
        const newItems = images.filter((i) => i.isNew === true);
        const existingItems = images.filter((i) => i.isNew === false && i.id !== '');

        const requests = [];

        // Create and upload new items
        if (newItems.length > 0) {
          const createNewItems = newItems.map((item) => {
            const child = {
              parent_id: parentId,
              page_location: page_location,

              name: 'icon',
              description: `${type} image`,
              is_hidden: item.is_hidden,
              language: 'vi',
            };

            return this.postData(child).pipe(
              switchMap((res) => {
                // Upload image after creating
                return this.sysService.apiSystemSettingIdUploadImagePut(res.data.id, item.file);
              })
            );
          });

          requests.push(...createNewItems);
        }

        // Update existing items (is_hidden status)
        if (existingItems.length > 0) {
          const updateExistingItems = existingItems.map((item) => {
            const updateObj = {
              parent_id: item.parent_id,
              page_location: page_location,
              value: item.value,
              name: 'icon',
              description: `${type} image`,
              is_hidden: item.is_hidden,
              language: 'vi',
            };

            return this.putData(updateObj, item.id);
          });

          requests.push(...updateExistingItems);
        }

        return requests.length > 0 ? forkJoin(requests) : of([]);
      })
    );
  }

  getHotLineAndImage(type: 'HOTLINE-CALL' | 'VIDEO' | 'EMAIL') {
    return this.sysService
      .apiSystemSettingGet(`type==${type}`)
      .pipe(catchError(() => of({ success: false, data: { collection: [] } })));
  }

  renderData() {
    forkJoin([
      this.getData(this.type.header),
      this.getData(this.type.favicon),
      this.getData(this.type.banner),
      this.getHotLineAndImage(this.type.hotline as 'HOTLINE-CALL'),
      this.getHotLineAndImage(this.type.video as 'VIDEO'),
      this.getHotLineAndImage(this.type.email as 'EMAIL'),
    ]).subscribe(([logoList, faviconList, banners, hotline, linkYtb, email]) => {
      console.log('list danh sach banner', banners);
      this.lstLogo = logoList;
      this.lstFavicon = faviconList;
      this.lstBanner = banners;
      this.hotline =
        hotline.success &&
        hotline.data.collection.length > 0 &&
        hotline.data.collection[0].children &&
        hotline.data.collection[0].children.length > 0
          ? hotline.data.collection[0].children[0].value
          : '';
      this.linkYtb =
        linkYtb.success &&
        linkYtb.data.collection.length > 0 &&
        linkYtb.data.collection[0].children &&
        linkYtb.data.collection[0].children.length > 0
          ? linkYtb.data.collection[0].children[0].value
          : '';

      this.email =
        email.success &&
        email.data.collection.length > 0 &&
        email.data.collection[0].children &&
        email.data.collection[0].children.length > 0
          ? email.data.collection[0].children[0].value
          : '';

      this.storeSetting.updateSettings({
        logos: logoList,
        favicons: faviconList,
        banners: banners,
        hotline: this.hotline,
        videoLink: this.linkYtb,
        email: this.email,
      });

      this.cdr.detectChanges();
    });
  }

  private removeFromList(item: MediaItem, type: 'Logo' | 'Favicon' | 'Banner') {
    if (type === 'Logo') {
      this.lstLogo = this.lstLogo.filter((data) => data !== item);
    } else if (type === 'Favicon') {
      this.lstFavicon = this.lstFavicon.filter((data) => data !== item);
    } else {
      this.lstBanner = this.lstBanner.filter((data) => data !== item);
    }

    this.cdr.detectChanges();
  }

  deleteImage(item: MediaItem, type: 'Logo' | 'Favicon' | 'Banner') {
    event.stopPropagation();

    if (item.id !== '') {
      this.sysService.apiSystemSettingIdDelete(item.id).subscribe({
        next: (res) => {
          if (res) {
            this.removeFromList(item, type);
            this.toastr.success('Xóa thành công');
          }
        },
        error: (err) => {
          this.toastr.error('Lỗi khi xóa:', err);
        },
      });
    } else {
      this.removeFromList(item, type);
    }
  }

  private saveTextSetting(type: string, value: string) {
    return this.checkExistType(type).pipe(
      switchMap((parentResult) => {
        const parentObj = {
          type,
          sort_order: 0,
          parent_title: type,
          page_location: '',
          language: 'vi',
        };

        if (parentResult.exists && parentResult.id) {
          return of(parentResult.id);
        }
        return this.postData(parentObj).pipe(map((r) => r.data.id));
      }),

      switchMap((parentId) => {
        return this.sysService.apiSystemSettingGet(`type==${type}`).pipe(
          switchMap((res) => {
            if (!res.success || !res.data.collection || res.data.collection.length === 0) {
              const childObj = {
                parent_id: parentId,
                page_location: '',
                value: value,
                name: type,
                description: type,
                is_hidden: false,
                language: 'vi',
              };
              return this.postData(childObj);
            }

            const parentItem = res.data.collection[0];
            const children = parentItem.children || [];

            const childObj = {
              parent_id: parentItem.id,
              page_location: '',
              value: value,
              name: type,
              description: type,
              is_hidden: false,
              language: 'vi',
            };

            if (children && children.length > 0) {
              const targetChild = children.find((c) => c.is_hidden === false) || children[0];

              return this.putData(childObj, targetChild.id);
            }

            return this.postData(childObj);
          })
        );
      })
    );
  }
  onSave() {
    if (this.hotline === '' || this.linkYtb === '' || this.email === '') {
      // Thêm điều kiện email
      this.toastr.error('Hotline, Email và Video không được rỗng');
    } else {
      console.log('hotline, linkytb, email', this.hotline, this.linkYtb, this.email); // Thêm email vào log

      forkJoin([
        this.saveImageByType(this.type.header, this.lstLogo, 'HEADER'),
        this.saveImageByType(this.type.favicon, this.lstFavicon, 'BROWSER_TAB'),
        this.saveImageByType(this.type.banner, this.lstBanner, 'BANNER'),
        this.saveTextSetting(this.type.hotline, this.hotline),
        this.saveTextSetting(this.type.video, this.linkYtb),
        this.saveTextSetting(this.type.email, this.email), // THÊM DÒNG NÀY
      ]).subscribe({
        next: (results) => {
          this.toastr.success('Lưu thành công');
          this.storeSetting.updateSettings({
            logos: this.lstLogo,
            favicons: this.lstFavicon,
            banners: this.lstBanner,
            hotline: this.hotline,
            videoLink: this.linkYtb,
            email: this.email, // THÊM DÒNG NÀY
          });
          this.renderData();
        },
        error: (err) => {
          this.toastr.error('Có lỗi xảy ra khi lưu:', err);
        },
      });
    }
  }
}
